import { inject, injectable } from 'inversify';
import { FloodlightsPerPlatformPerAdvertiser } from '../../../../core/dv360/model/floodlight.ts';
import { Dv360FloodlightPort } from '../../../../core/dv360/port/dv360-floodlight.port.ts';
import INJECTION_TOKENS from '../../../../core/generic/ioc/injection-tokens.ts';
import type SimpleHttpService from '../../../../core/generic/simple-http-service.port';
import {
  Dv360FloodlightMapper,
  Dv360FloodlightsPerPlatformResponse,
} from './dv360-floodlight.mapper.ts';

@injectable()
export class Dv360FloodlightRepository implements Dv360FloodlightPort {
  constructor(
    @inject(INJECTION_TOKENS.DV360_API_HTTP_SERVICE)
    private readonly httpService: SimpleHttpService,
    @inject(INJECTION_TOKENS.DV360_FLOODLIGHT_MAPPER) private readonly mapper: Dv360FloodlightMapper
  ) {}

  async getFloodlights(
    clientId: string,
    partnerId: string
  ): Promise<FloodlightsPerPlatformPerAdvertiser> {
    const response = await this.httpService.get<Dv360FloodlightsPerPlatformResponse>(
      `/v1/clients/${clientId}/partners/${partnerId}/floodlights`
    );

    return {
      cm360: this.mapper.mapAdvertiserFloodlights(response.cm360?.advertisers ?? {}),
      dv360: this.mapper.mapAdvertiserFloodlights(response.dv360?.advertisers ?? {}),
    };
  }
}
